"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiReportCombinedResponseDto = exports.BillingApiReportCombinedProductResponseDto = exports.BillingApiReportMemberCombinedResponseDto = void 0;
const swagger_1 = require("../../../../swagger-fake");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const billing_api_report_combined_status_enum_1 = require("../enums/billing-api-report-combined-status.enum");
const types_1 = require("../../../billing-api-account/types");
const billing_api_report_combined_type_enum_1 = require("../enums/billing-api-report-combined-type.enum");
let BillingApiReportMemberCombinedResponseDto = class BillingApiReportMemberCombinedResponseDto {};
__decorate([(0, swagger_1.ApiProperty)({
  description: "ID пользователя"
}), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiReportMemberCombinedResponseDto.prototype, "id", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Уникальный код для формирования ссылки"
}), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiReportMemberCombinedResponseDto.prototype, "slug", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Имя"
}), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiReportMemberCombinedResponseDto.prototype, "first_name", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Фамилия"
}), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiReportMemberCombinedResponseDto.prototype, "last_name", void 0);
BillingApiReportMemberCombinedResponseDto = __decorate([(0, class_transformer_1.Exclude)()], BillingApiReportMemberCombinedResponseDto);
exports.BillingApiReportMemberCombinedResponseDto = BillingApiReportMemberCombinedResponseDto;
/**
 * Краткие сведения о купленном товаре
 */
let BillingApiReportCombinedProductResponseDto = class BillingApiReportCombinedProductResponseDto {};
__decorate([(0, swagger_1.ApiProperty)({
  description: "ID купленного объекта"
}), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiReportCombinedProductResponseDto.prototype, "id", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Уникальный код для формирования ссылки"
}), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiReportCombinedProductResponseDto.prototype, "slug", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Наименование"
}), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiReportCombinedProductResponseDto.prototype, "title", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Тип товара"
}), (0, class_transformer_1.Expose)(), __metadata("design:type", Object)], BillingApiReportCombinedProductResponseDto.prototype, "type", void 0);
BillingApiReportCombinedProductResponseDto = __decorate([(0, class_transformer_1.Exclude)()], BillingApiReportCombinedProductResponseDto);
exports.BillingApiReportCombinedProductResponseDto = BillingApiReportCombinedProductResponseDto;
/**
 * Запись истории операций
 */
let BillingApiReportCombinedResponseDto = class BillingApiReportCombinedResponseDto {};
__decorate([(0, swagger_1.ApiProperty)({
  description: "ID платежа, возврата, выплаты или транзакции"
}), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiReportCombinedResponseDto.prototype, "id", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Тип операции",
  enum: billing_api_report_combined_type_enum_1.BillingApiReportCombinedTypeEnum
}), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiReportCombinedResponseDto.prototype, "type", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Сумма в валюте оплаты",
  format: "decimal",
  example: "15.00"
}), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiReportCombinedResponseDto.prototype, "amount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Код валюты оплаты",
  example: "USD"
}), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiReportCombinedResponseDto.prototype, "currencyCode", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Кто купил или у кого купил (пользователь отображаемый в отчёте; зависит от типа операции)",
  type: () => BillingApiReportMemberCombinedResponseDto
}), (0, class_transformer_1.Expose)(), (0, class_transformer_1.Type)(() => BillingApiReportMemberCombinedResponseDto), __metadata("design:type", Object)], BillingApiReportCombinedResponseDto.prototype, "person", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Статус операции",
  enum: billing_api_report_combined_status_enum_1.BillingApiReportCombinedStatusEnum
}), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiReportCombinedResponseDto.prototype, "status", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Опциональный комментарий",
  nullable: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), __metadata("design:type", Object)], BillingApiReportCombinedResponseDto.prototype, "comment", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Что куплено или что продано",
  type: () => BillingApiReportCombinedProductResponseDto
}), (0, class_transformer_1.Expose)(), (0, class_transformer_1.Type)(() => BillingApiReportCombinedProductResponseDto), __metadata("design:type", Object)], BillingApiReportCombinedResponseDto.prototype, "product", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Счёт которым было оплачено, либо счёт на который сделан вывод средств, либо счёт на который вернулся возврат",
  type: () => types_1.BillingApiAccountResponseDto
}), (0, class_transformer_1.Expose)(), (0, class_transformer_1.Type)(() => types_1.BillingApiAccountResponseDto), __metadata("design:type", Object)], BillingApiReportCombinedResponseDto.prototype, "account", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Дата и время операции",
  format: "date-time"
}), (0, class_transformer_1.Expose)(), __metadata("design:type", Date)], BillingApiReportCombinedResponseDto.prototype, "createdAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Сведения о контрагенте биллинга с которым был взаимосрасчёт"
}), (0, class_transformer_1.Expose)({
  groups: ['back']
}), __metadata("design:type", Object)], BillingApiReportCombinedResponseDto.prototype, "personContractor", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Сведения о сделке и начислениях в ней"
}), (0, class_transformer_1.Expose)({
  groups: ['back']
}), __metadata("design:type", Object)], BillingApiReportCombinedResponseDto.prototype, "order", void 0);
BillingApiReportCombinedResponseDto = __decorate([(0, class_transformer_1.Exclude)()], BillingApiReportCombinedResponseDto);
exports.BillingApiReportCombinedResponseDto = BillingApiReportCombinedResponseDto;
